import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import TableCellHeader from "@saleor/components/TableCellHeader";
import { maybe, renderCollection } from "@saleor/misc";
import { batchDetailsQuery_batchDetails_data } from "@saleor/reports/batch/types/batchDetailsQuery";
import { formatDate } from "@saleor/reports/batch/utils/handlers";
// import { currencyFormat } from "@saleor/utils/formatters/currencyFormat";
import moment from "moment-timezone";
import * as React from "react";
import { FormattedMessage } from "react-intl";

interface BatchHistoryDetailsListProps {
  batchDetails: batchDetailsQuery_batchDetails_data[];
}

const BatchHistoryDetailsList: React.FC<BatchHistoryDetailsListProps> = props => {
  const { batchDetails } = props;

  return (
    <ResponsiveTable>
      <TableHead>
        <TableCellHeader>
          <FormattedMessage defaultMessage="Mall" />
        </TableCellHeader>
        <TableCellHeader>
          <FormattedMessage defaultMessage="Brand" />
        </TableCellHeader>
        <TableCellHeader>
          <FormattedMessage defaultMessage="Company Name" />
        </TableCellHeader>
        <TableCellHeader>
          <FormattedMessage defaultMessage="Period Covered" />
        </TableCellHeader>
        <TableCellHeader>
          <FormattedMessage defaultMessage="Net Settlement" />
        </TableCellHeader>
        <TableCellHeader>
          <FormattedMessage defaultMessage="Settlement Date" />
        </TableCellHeader>
      </TableHead>
      <TableBody>
        {batchDetails &&
          renderCollection(
            batchDetails,
            (batchDetail: batchDetailsQuery_batchDetails_data) => (
              <TableRow>
                <TableCell>
                  {maybe(() => batchDetail.mall_name, null) ? (
                    batchDetail.mall_name.toUpperCase()
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>
                <TableCell>
                  {maybe(() => batchDetail.brand_name, null) ? (
                    batchDetail.brand_name.toUpperCase()
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>
                <TableCell>
                  {maybe(() => batchDetail.company_name, null) ? (
                    batchDetail.company_name.toUpperCase()
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>
                <TableCell>
                  {maybe(() => batchDetail.coverage_start_date, null) ? (
                    formatDate(batchDetail.coverage_start_date) +
                    " - " +
                    formatDate(batchDetail.coverage_end_date)
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>
                <TableCell>
                  {maybe(() => batchDetail.net_settlement, null) ? (
                    batchDetail.net_settlement.toFixed(2)
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>
                <TableCell>
                  {maybe(() => batchDetail.settlement_date, null) ? (
                    moment(batchDetail.settlement_date).format("MM/DD/YYYY")
                  ) : (
                    <Skeleton />
                  )}
                </TableCell>
              </TableRow>
            ),
            () => (
              <TableRow>
                <TableCell colSpan={6}>
                  <FormattedMessage defaultMessage="No details found" />
                </TableCell>
              </TableRow>
            )
          )}
      </TableBody>
    </ResponsiveTable>
  );
};

export default BatchHistoryDetailsList;
